export default employmentType => {
  const et = employmentType.toLowerCase();
  if (et === "cdi" || et === "permanent") return "talent";
  if (et === "freelance" || et === "contract") return "clubfreelance";
  return null;
};
